document.addEventListener("DOMContentLoaded", function () {

  /* =====================================================
     QUICK VIEW POPUP
  ===================================================== */

  const modal = document.createElement("div");

  modal.className = "custom-quick-view-modal";

  modal.innerHTML = `
    <div class="custom-quick-view-box">

      <button
        type="button"
        class="custom-quick-view-close"
        aria-label="Close"
      >
        ×
      </button>

      <div class="custom-quick-view-content">

        <!-- LEFT IMAGE -->

        <div class="custom-quick-view-image-wrap">

          <img
            class="custom-quick-view-image"
            src=""
            alt=""
          >

          <button
            type="button"
            class="custom-quick-view-prev"
          >
            ‹
          </button>

          <button
            type="button"
            class="custom-quick-view-next"
          >
            ›
          </button>

        </div>


        <!-- RIGHT DETAILS -->

        <div class="custom-quick-view-details">

          <h2 class="custom-quick-view-title"></h2>

          <div class="custom-quick-view-price"></div>

          <div class="custom-quick-view-description"></div>

          <a
            class="custom-quick-view-details-link"
            href="#"
          >
            VIEW DETAILS
          </a>

          <label class="custom-quick-view-quantity-label">
            Quantity
          </label>

          <div class="custom-quick-view-quantity">

            <button
              type="button"
              class="custom-quick-view-minus"
            >
              −
            </button>

            <input
              type="number"
              class="custom-quick-view-qty"
              value="1"
              min="1"
              max="99"
            >

            <button
              type="button"
              class="custom-quick-view-plus"
            >
              +
            </button>

          </div>

          <button
            type="button"
            class="custom-quick-view-cart"
          >
            ADD TO CART
          </button>

        </div>

      </div>

    </div>
  `;

  document.body.appendChild(modal);


  /* =====================================================
     CSS
  ===================================================== */

  const style = document.createElement("style");

  style.textContent = `

    .custom-quick-view-modal {
      position: fixed;
      inset: 0;
      z-index: 999999;
      background: rgba(0,0,0,.65);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 14px;
      opacity: 0;
      visibility: hidden;
      transition: opacity .25s ease, visibility .25s ease;
    }

    .custom-quick-view-modal.is-open {
      opacity: 1;
      visibility: visible;
    }


    .custom-quick-view-box {
      position: relative;
      width: 100%;
      max-width: 1250px;
      max-height: 92vh;
      overflow-y: auto;
      background: #fff;
      border-radius: 12px;
      padding: 38px;
      transform: translateY(20px);
      transition: transform .3s ease;
    }

    .custom-quick-view-modal.is-open
    .custom-quick-view-box {
      transform: translateY(0);
    }


    /* CLOSE */

    .custom-quick-view-close {
      position: absolute;
      top: 10px;
      right: 12px;
      width: 38px;
      height: 38px;
      border: none;
      background: transparent;
      color: #111;
      font-size: 30px;
      line-height: 1;
      cursor: pointer;
      z-index: 20;
    }

    .custom-quick-view-close:hover {
      color: #F85301;
    }


    /* MAIN LAYOUT */

    .custom-quick-view-content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 38px;
      align-items: center;
    }


    /* IMAGE */

    .custom-quick-view-image-wrap {
      position: relative;
      width: 100%;
      height: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .custom-quick-view-image {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }


    /* IMAGE ARROWS */

    .custom-quick-view-prev,
    .custom-quick-view-next {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 52px;
      height: 52px;
      border: none;
      border-radius: 50%;
      background: #fff;
      color: #111;
      font-size: 34px;
      line-height: 1;
      cursor: pointer;
      box-shadow: 0 3px 15px rgba(0,0,0,.15);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .custom-quick-view-prev {
      left: 5px;
    }

    .custom-quick-view-next {
      right: 5px;
    }

    .custom-quick-view-prev:hover,
    .custom-quick-view-next:hover {
      background: #F85301;
      color: #fff;
    }


    /* DETAILS */

    .custom-quick-view-details {
      padding-right: 18px;
    }


    .custom-quick-view-title {
      margin: 0 0 12px;
      color: #111;
      font-size: 32px;
      line-height: 1.25;
      font-weight: 700;
    }


    /* PRICE */

    .custom-quick-view-price {
      display: flex;
      align-items: center;
      gap: 12px;
      flex-wrap: wrap;
      margin-bottom: 22px;
    }

    .custom-qv-current-price {
      color: #F85301;
      font-size: 30px;
      font-weight: 800;
      line-height: 1.2;
    }

    .custom-qv-compare-price {
      color: #111;
      font-size: 18px;
      text-decoration: line-through;
    }


    /* DESCRIPTION */

    .custom-quick-view-description {
      color: #555;
      font-size: 16px;
      line-height: 1.6;
      margin-bottom: 18px;

      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }


    /* VIEW DETAILS */

    .custom-quick-view-details-link {
      display: inline-block;
      margin-bottom: 24px;
      color: #111;
      font-size: 15px;
      font-weight: 700;
      text-decoration: underline;
      text-underline-offset: 4px;
    }

    .custom-quick-view-details-link:hover {
      color: #F85301;
    }


    /* QUANTITY */

    .custom-quick-view-quantity-label {
      display: block;
      margin-bottom: 8px;
      color: #111;
      font-size: 15px;
      font-weight: 700;
    }

    .custom-quick-view-quantity {
      display: flex;
      width: max-content;
      height: 56px;
      border: 1px solid #ddd;
      border-radius: 6px;
      margin-bottom: 22px;
      overflow: hidden;
    }

    .custom-quick-view-quantity button {
      width: 52px;
      height: 100%;
      border: none;
      background: #fff;
      color: #111;
      font-size: 22px;
      cursor: pointer;
    }

    .custom-quick-view-quantity button:hover {
      color: #F85301;
    }

    .custom-quick-view-qty {
      width: 55px;
      height: 100%;
      border: none;
      border-left: 1px solid #ddd;
      border-right: 1px solid #ddd;
      text-align: center;
      font-size: 17px;
      outline: none;
    }


    /* ADD TO CART */

    .custom-quick-view-cart {
      width: 100%;
      min-height: 62px;
      border: none;
      border-radius: 6px;
      background: #F85301;
      color: #fff;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: .3px;
      cursor: pointer;
    }

    .custom-quick-view-cart:hover {
      background: #d94400;
    }

    .custom-quick-view-cart:disabled {
      opacity: .65;
      cursor: not-allowed;
    }


    /* MOBILE */

    @media screen and (max-width: 749px) {

      .custom-quick-view-modal {
        padding: 8px;
      }

      .custom-quick-view-box {
        padding: 28px 18px 22px;
        max-height: 94vh;
      }

      .custom-quick-view-content {
        grid-template-columns: 1fr;
        gap: 12px;
      }

      .custom-quick-view-image-wrap {
        height: 300px;
      }

      .custom-quick-view-title {
        font-size: 23px;
      }

      .custom-qv-current-price {
        font-size: 24px;
      }

      .custom-quick-view-details {
        padding-right: 0;
      }

      .custom-quick-view-prev,
      .custom-quick-view-next {
        width: 42px;
        height: 42px;
        font-size: 28px;
      }

      .custom-quick-view-cart {
        min-height: 54px;
        font-size: 16px;
      }

    }

  `;

  document.head.appendChild(style);


  /* =====================================================
     ELEMENTS
  ===================================================== */

  const closeButton =
    modal.querySelector(".custom-quick-view-close");

  const image =
    modal.querySelector(".custom-quick-view-image");

  const title =
    modal.querySelector(".custom-quick-view-title");

  const price =
    modal.querySelector(".custom-quick-view-price");

  const description =
    modal.querySelector(".custom-quick-view-description");

  const detailsLink =
    modal.querySelector(".custom-quick-view-details-link");

  const addButton =
    modal.querySelector(".custom-quick-view-cart");

  const quantityInput =
    modal.querySelector(".custom-quick-view-qty");

  const minusButton =
    modal.querySelector(".custom-quick-view-minus");

  const plusButton =
    modal.querySelector(".custom-quick-view-plus");

  const previousButton =
    modal.querySelector(".custom-quick-view-prev");

  const nextButton =
    modal.querySelector(".custom-quick-view-next");


  let currentProduct = null;
  let currentVariant = null;
  let currentImages = [];
  let currentImageIndex = 0;


  /* =====================================================
     MONEY
  ===================================================== */

  function formatMoney(cents) {

    if (
      typeof Shopify !== "undefined" &&
      Shopify.formatMoney
    ) {
      return Shopify.formatMoney(cents);
    }

    return "AED " +
      (Number(cents) / 100).toFixed(2);
  }


  /* =====================================================
     IMAGE
  ===================================================== */

  function updateImage() {

    if (!currentImages.length) return;

    image.src =
      currentImages[currentImageIndex];

  }


  /* =====================================================
     OPEN
  ===================================================== */

  function openModal() {

    modal.classList.add("is-open");

    document.body.style.overflow = "hidden";

  }


  /* =====================================================
     CLOSE
  ===================================================== */

  function closeModal() {

    modal.classList.remove("is-open");

    document.body.style.overflow = "";

  }


  /* =====================================================
     QUICK VIEW CLICK
  ===================================================== */

  document.addEventListener("click", async function (event) {

    const button =
      event.target.closest(
        ".custom-quick-view-btn, .canyon-quick-view"
      );

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();


    let productUrl =
      button.getAttribute("data-product-url");


    const handle =
      button.getAttribute("data-product-handle");


    if (!productUrl && handle) {

      productUrl =
        "/products/" + handle;

    }


    if (!productUrl) return;


    openModal();


    title.textContent = "Loading...";
    price.innerHTML = "";
    description.innerHTML = "";
    image.src = "";
    addButton.disabled = true;


try {

  let productEndpoint = productUrl;

  /*
   * Product URL ko Shopify .js endpoint mein convert karein
   */

  if (handle) {

    productEndpoint =
      "/products/" +
      handle +
      ".js";

  } else {

    try {

      const parsedUrl =
        new URL(
          productUrl,
          window.location.origin
        );

      productEndpoint =
        parsedUrl.pathname.replace(
          /\/$/,
          ""
        ) + ".js";

    } catch (urlError) {

      productEndpoint =
        productUrl
          .split("?")[0]
          .replace(/\/$/, "") +
        ".js";

    }

  }


  const response =
    await fetch(
      productEndpoint,
      {
        headers: {
          "Accept":
            "application/json"
        }
      }
    );


  if (!response.ok) {
    throw new Error(
      "Product not found: " +
      response.status
    );
  }


      const product =
        await response.json();


      currentProduct =
        product;


      currentVariant =
        product.variants.find(
          variant => variant.available
        ) ||
        product.variants[0];


      currentImages =
        product.images || [];


      currentImageIndex = 0;


      /* TITLE */

      title.textContent =
        product.title;


      /* IMAGE */

      if (currentImages.length) {

        image.src =
          currentImages[0];

        image.alt =
          product.title;

      }


      /* ARROWS */

      if (currentImages.length > 1) {

        previousButton.style.display =
          "flex";

        nextButton.style.display =
          "flex";

      } else {

        previousButton.style.display =
          "none";

        nextButton.style.display =
          "none";

      }


      /* PRICE */

      let compareHTML = "";


      if (
        product.compare_at_price &&
        product.compare_at_price >
          product.price
      ) {

        compareHTML = `
          <span class="custom-qv-compare-price">
            ${formatMoney(
              product.compare_at_price
            )}
          </span>
        `;

      }


      price.innerHTML = `

        <span class="custom-qv-current-price">
          ${formatMoney(product.price)}
        </span>

        ${compareHTML}

      `;


      /* DESCRIPTION */

      description.innerHTML =
        product.description || "";


      /* DETAILS */

      detailsLink.href =
        "/products/" +
        product.handle;


      /* QUANTITY */

      quantityInput.value = 1;


      /* ADD TO CART */

      if (
        currentVariant &&
        currentVariant.available
      ) {

        addButton.disabled = false;

        addButton.textContent =
          "ADD TO CART";

      } else {

        addButton.disabled = true;

        addButton.textContent =
          "SOLD OUT";

      }


    } catch (error) {

      console.error(
        "Quick View:",
        error
      );

      title.textContent =
        "Unable to load product.";

      addButton.disabled = true;

    }

  });


  /* =====================================================
     IMAGE PREVIOUS
  ===================================================== */

  previousButton.addEventListener(
    "click",
    function () {

      if (!currentImages.length) return;

      currentImageIndex--;

      if (currentImageIndex < 0) {

        currentImageIndex =
          currentImages.length - 1;

      }

      updateImage();

    }
  );


  /* =====================================================
     IMAGE NEXT
  ===================================================== */

  nextButton.addEventListener(
    "click",
    function () {

      if (!currentImages.length) return;

      currentImageIndex++;

      if (
        currentImageIndex >=
        currentImages.length
      ) {

        currentImageIndex = 0;

      }

      updateImage();

    }
  );


  /* =====================================================
     QUANTITY MINUS
  ===================================================== */

  minusButton.addEventListener(
    "click",
    function () {

      let quantity =
        Number(quantityInput.value) || 1;

      quantity =
        Math.max(
          1,
          quantity - 1
        );

      quantityInput.value =
        quantity;

    }
  );


  /* =====================================================
     QUANTITY PLUS
  ===================================================== */

  plusButton.addEventListener(
    "click",
    function () {

      let quantity =
        Number(quantityInput.value) || 1;

      quantity =
        Math.min(
          99,
          quantity + 1
        );

      quantityInput.value =
        quantity;

    }
  );


  /* =====================================================
     ADD TO CART
  ===================================================== */

  addButton.addEventListener(
    "click",
    async function () {

      if (
        !currentVariant ||
        !currentVariant.available
      ) {
        return;
      }


      const quantity =
        Math.max(
          1,
          Number(
            quantityInput.value
          ) || 1
        );


      addButton.disabled = true;

      addButton.textContent =
        "ADDING...";


      try {

        const response =
          await fetch(
            "/cart/add.js",
            {
              method: "POST",

              headers: {
                "Content-Type":
                  "application/json",
                "Accept":
                  "application/json"
              },

              body:
                JSON.stringify({
                  items: [
                    {
                      id:
                        currentVariant.id,

                      quantity:
                        quantity
                    }
                  ]
                })
            }
          );


        if (!response.ok) {
          throw new Error(
            "Add to cart failed"
          );
        }


        await response.json();


        addButton.textContent =
          "ADDED TO CART ✓";


        document.dispatchEvent(
          new CustomEvent(
            "cart:refresh"
          )
        );


        setTimeout(
          function () {

            closeModal();

            addButton.textContent =
              "ADD TO CART";

            addButton.disabled =
              false;

          },
          1000
        );


      } catch (error) {

        console.error(
          "Cart:",
          error
        );


        addButton.textContent =
          "TRY AGAIN";

        addButton.disabled =
          false;

      }

    }
  );


  /* =====================================================
     CLOSE
  ===================================================== */

  closeButton.addEventListener(
    "click",
    closeModal
  );


  modal.addEventListener(
    "click",
    function (event) {

      if (
        event.target === modal
      ) {
        closeModal();
      }

    }
  );


  document.addEventListener(
    "keydown",
    function (event) {

      if (
        event.key === "Escape"
      ) {
        closeModal();
      }

    }
  );

});